import { Link } from 'react-router-dom'
import { usePageData } from '_metronic/layout/core'
import { KTSVG } from '_metronic/helpers'

const PageBreadCrumb = ({ statusTitle }: { statusTitle?: string }) => {
  const { pageTitle, pageDescription, pageBreadcrumbs } = usePageData()


  // FIXME: reduce padding of Title, BreadCrumb
  return (
    <div className='card h-100'>
      <div className='card-header ribbon ribbon-end ribbon-clip'>
        <div className='card-title' style={{ padding: 0 }}>
          <h3 className='fw-bolder'>{pageTitle}</h3>
        </div>
        {statusTitle && (
          <div className='ribbon-label bg-primary' style={{fontSize:'1.6rem',textTransform:'capitalize'}}>
            {statusTitle} <span className='ribbon-inner'></span>
          </div>
        )}
      </div>
      <div className='card-body'>
        {pageDescription && <p>{pageDescription}</p>}
        <div className='d-flex align-items-center'>
          <ul className='breadcrumb breadcrumb-transparent breadcrumb-dot font-weight-bold p-0 font-size-sm'>
            {(pageBreadcrumbs ?? []).map((breadcrumb, index) => {
              return index === 0 ? (
                <li key={index} className='breadcrumb-item'>
                  <Link to={breadcrumb.path}>
                    {breadcrumb.icon && (
                      <KTSVG path={breadcrumb.icon} className='svg-icon-2 mr-2' />
                    )}{' '}
                    {breadcrumb.title}
                  </Link>
                </li>
              ) : (
                <li key={index} className='breadcrumb-item'>
                  <Link to={breadcrumb.path}>{breadcrumb.title}</Link>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default PageBreadCrumb
